import React from 'react';
import { SINGLEIMAGE_URL } from '../config/apiConfig';

function SingleImagePage() {
  const [imageUrl, setImageUrl] = React.useState('');

  React.useEffect(() => {
    // Función para obtener la imagen
    const fetchImage = () => {
      fetch(SINGLEIMAGE_URL)
        .then(response => response.json())
        .then(data => {
          setImageUrl(data.image_url); // Asegúrate de que el backend devuelve "image_url"
        })
        .catch(error => {
          console.error('Error al obtener la imagen:', error);
        });
    };

    // Llamar la primera vez al montar el componente
    fetchImage();

    // Configurar el intervalo para llamar cada minuto (60000ms)
    const intervalId = setInterval(fetchImage, 60000);

    // Limpiar el intervalo al desmontar el componente
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className="single-image-page">
      {imageUrl ? (
        <div className="image-container">
          <img src={imageUrl} alt="Imagen del servidor" className="image" />
        </div>
      ) : (
        <p className="loading">Cargando imagen...</p>
      )}
    </div>
  );
}

export default SingleImagePage;
